import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Checkbox$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.zb3_1.ib7_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function Checkbox$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.zb3_1.ib7_1.checked = value;
  return Unit_instance;
}
var CheckboxClass;
function Checkbox() {
  if (CheckboxClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.jba(this.ob6_1.ybe(ClickableSemantic_getInstance()));
        this.tb5_1.xb3_1 = 'input';
        var tmp0 = this.tb5_1.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'checkbox';
        tmp0.ib7_1.type = value;
        this.tb5_1.hb4_1.v('checkbox');
        this.tb5_1.hb4_1.v('checkResponsive');
        this.tb5_1.hb4_1.v('clickable');
        var tmp = this;
        var tmp_0 = this.tb5_1;
        var tmp_1 = Checkbox$checked$lambda;
        tmp.cbk_1 = vprop(tmp_0, 'input', tmp_1, Checkbox$checked$lambda_0);
      }
    }
    initMetadataForClass($, 'Checkbox');
    CheckboxClass = $;
  }
  return CheckboxClass;
}
//region block: exports
export {
  Checkbox as Checkbox2he0oy51inwu6,
};
//endregion

//# sourceMappingURL=Checkbox.commonHtml.mjs.map
